import { render, staticRenderFns } from "./NpsGradientButtonsColored.vue?vue&type=template&id=03e27c58&"
import script from "./NpsGradientButtonsColored.vue?vue&type=script&lang=ts&"
export * from "./NpsGradientButtonsColored.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports